import React, { createContext, useContext, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { setAuthTokenStorageMethods, } from 'lincd-auth/utils/token';
import { Preferences } from '@capacitor/preferences';
import { App } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';
export const CapacitorContext = createContext(null);
function useCapacitorProvider() {
    return {
        Capacitor,
    };
}
export function CapacitorProvider({ children }) {
    const capacitor = useCapacitorProvider();
    const navigate = useNavigate();
    /**
     * AppUrlListener, used to handle deep links
     */
    useEffect(() => {
        App.addListener('appUrlOpen', (event) => {
            // use URL constructor to parse the URL
            // example:
            // https://beerswift.com/tabs/tab2 --> /tabs/tab2
            // https://www.peacegame.earth/tabs --> /tabs
            const url = new URL(event.url);
            // extract the path from the URL
            const slug = url.pathname;
            // log the deeplink URL
            if (process.env.NODE_ENV === 'staging') {
                console.log('deeplink: ', slug);
            }
            if (slug) {
                navigate(slug);
            }
        });
    }, []);
    /**
     * set the storage token methods for Capacitor
     */
    useEffect(() => {
        const getTokenFn = async (key) => {
            const token = await Preferences.get({ key });
            return token === null || token === void 0 ? void 0 : token.value;
        };
        const setTokenFn = async (key, value) => {
            await Preferences.set({
                key: key,
                value: value,
            });
        };
        const removeTokenFn = async (key) => {
            await Preferences.remove({ key: key });
        };
        // set the preferences storage methods only for native platforms
        // and run this effect only once during component mount
        if (Capacitor.isNativePlatform()) {
            setAuthTokenStorageMethods(getTokenFn, setTokenFn, removeTokenFn);
        }
    }, []);
    return (React.createElement(CapacitorContext.Provider, { value: capacitor }, children));
}
export const useCapacitor = () => {
    const capacitor = useContext(CapacitorContext);
    if (!capacitor) {
        throw new Error('useCapacitor must be used within a <CapacitorProvider>');
    }
    return capacitor;
};
//# sourceMappingURL=useCapacitor.js.map